import React from 'react';
import Children from '../../interfaces/children.interface';
import Gap from '../../interfaces/gap.interface';
import Layer from '../../interfaces/layer.interface';
import TestId from '../../interfaces/test-id.interface';

export interface Props extends Children, Layer, Gap, TestId {
  /** Styles the message accordingly (notice/info/warning/error/success, defaults to `notice`) */
  type?: 'notice' | 'info' | 'warning' | 'error' | 'success';

  /** Renders the message in a block- or inline-style (defaults to `block`) */
  variant?: 'block' | 'inline';
}

export const colors = new Map([
  ['notice', 'gray'],
  ['info', 'blue'],
  ['warning', 'orange'],
  ['error', 'red'],
  ['success', 'green'],
]);

/** Get the styles according to the given variant and color */
const style = (variant: string, color = 'gray'): string =>
  `text-${color}-700 text-left ${
    variant === 'block' ? `block border py-2 px-4 bg-${color}-200 border-${color}-300` : 'inline'
  }`;

/** A message element to inform the user with */
const Message = ({
  children,
  gap = 'none',
  layer = 0,
  type = 'notice',
  variant = 'block',
  testId,
}: Props): React.ReactElement => (
  <div
    className={`skeletonize text-sm ${style(
      variant,
      colors.get(type)
    )} layer--${layer} gap--${gap}`}
    data-testid={testId}
  >
    {children}
  </div>
);

export default Message;
